import styled from 'styled-components';
import UniversalLink from './UniversalLink';
import { GUIDANCE_MODAL_BUTTON_WIDTH_PX } from '../../constants';

/* Needed to reach the inner div of the selectable button so
   all 3 buttons have aligned images and texts despite having different content size */
import { jsx as _jsx } from "react/jsx-runtime";
const StyledStretcher = styled.div.withConfig({
  displayName: "SelectableButtonLink__StyledStretcher",
  componentId: "sc-1oyi6q5-0"
})(["&{flex-basis:", ";& > a{height:100%;text-decoration:none !important;& > div{height:100%;}}}"], GUIDANCE_MODAL_BUTTON_WIDTH_PX);
const SelectableButtonLink = props => {
  return /*#__PURE__*/_jsx(StyledStretcher, {
    children: /*#__PURE__*/_jsx(UniversalLink, Object.assign({}, props))
  });
};
export default SelectableButtonLink;